import { render, staticRenderFns } from "./IconNeutralFace.vue?vue&type=template&id=26c2ec2c&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('26c2ec2c', component.options)
    } else {
      api.rerender('26c2ec2c', component.options)
    }
    module.hot.accept("./IconNeutralFace.vue?vue&type=template&id=26c2ec2c&functional=true&", function () {
      api.rerender('26c2ec2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/IconNeutralFace.vue"
export default component.exports